const practiceReport = [{
  path: 'practiceReport/index',
  component: resolve => require(['../../../../components/pages/studentresults/practiceReport'], resolve)
}, {
  path: 'practiceReport/upload',
  component: resolve => require(['../../../../components/pages/studentresults/practiceReport/upload'], resolve)
}]
export default practiceReport
